import React, { CSSProperties } from 'react'
import styles from './index.less'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const VerticalLineTitle = ({
  text,
  style = {},
  extra
}: { text: any, style?: CSSProperties, extra?: any }) => {
  return (
    <div className={cx('vertical-line-title')} style={style}>
      <div className={cx('vertical-line-title__line')}></div>
      <div className={cx('vertical-line-title__text')}>{text}</div>
      <div className={cx('vertical-line-title__extra')} style={{ flex: 1 }}>{extra}</div>
    </div>
  )
}

export default VerticalLineTitle
